import { formatDuration } from '@klv/molecules/unified-search-result-grid-item/hooks/formatDuration';
import { useTranslation } from '@klv/hooks/useTranslation';

import type { IUnifiedSearchResult } from '@klv/molecules/unified-search-results/types';

interface IProps {
  duration: IUnifiedSearchResult['duration'];
}
const Duration = ({ duration }: IProps) => {
  const { t } = useTranslation();
  const formattedDuration = formatDuration(duration, t);

  if (!duration || !formattedDuration) {
    return <></>;
  }

  return (
    <div className='p3'>
      {formattedDuration}
    </div>
  );
};

export default Duration;
